module.exports = __webpack_public_path__ + "img/icon-problem-brown.1041e490.svg";